import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  FileUploadWithPreview,
  Common,
  Permissionkeys,
  getBase64,
  Spinner,
  DropdownTreeSelect
} from '../../../config/react'
import 'react-summernote/dist/react-summernote.css'

const AddBanner = () => {
  const urlParams = useParams()
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const validator = useRef(
    new SimpleReactValidator({
      validators: {
        noDomain: {
          message: 'Custom links cannot contain a domain.',
          rule: (val) => !/^(https?:\/\/|www\.)/i.test(val), // Rejects if input contains a domain
          required: true
        }
      }
    })
  )
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [DeskImg, setDeskImg] = useState('invalid')

  const [IsDesktopImage, setDesktopImage] = useState(true)
  const [IsDesktopValidFile, setDesktopValidFile] = useState(true)
  const [IsDesktopImageSize, setDesktopImageSize] = useState(false)
  // const [IsDesktopShowImageRemoveLink, setIsDesktopShowImageRemoveLink] = useState(false)

  const [MobileImg, setMobileImg] = useState('')
  const [IsMobileImage, setMobileImage] = useState(true)
  const [IsMobileValidFile, setMobileValidFile] = useState(true)
  const [IsMobileImageSize, setMobileImageSize] = useState(false)
  // const [IsMobileShowImageRemoveLink, setIsMobileShowImageRemoveLink] = useState(false)

  const [Categories, setCategories] = useState([])
  const [Pages, setPages] = useState([])

  const [Inputs, setInputs] = useState({
    id: 0,
    name: '',
    btn_text: '',
    status: 0,
    prevDeskImg: '',
    prevMobImg: '',
    DesktopbtnX: '',
    DesktopbtnY: '',
    MobilebtnX: '',
    MobilebtnY: '',
    desk_btn_theme: 'white',
    mob_btn_theme: 'white',
    link_type: '',
    link: '',
    external_link: '',
    page_id: '',
    category_id: '',
    selectedCategoryId: ''
  })
  // dynamic button
  const [DesktopBtnPosition, setDesktopBtnPosition] = useState(null)
  const [MobileBtnPosition, setMobileBtnPosition] = useState(null)
  const DesktopImageRef = useRef(null)
  const MobileImageRef = useRef(null)

  // desktop btn
  const handleDesktopImageClick = (event) => {
    const rect = DesktopImageRef.current.getBoundingClientRect()
    const xPercentDesk = ((event.clientX - rect.left) / rect.width) * 100
    const yPercentDesk = ((event.clientY - rect.top) / rect.height) * 100
    setDesktopBtnPosition({ xPercentDesk, yPercentDesk })
    setInputs({ ...Inputs, DesktopbtnX: xPercentDesk, DesktopbtnY: yPercentDesk })
  }

  // mobile btn
  const handleMobileImageClick = (event) => {
    const rect = MobileImageRef.current.getBoundingClientRect()
    const xPercentMob = ((event.clientX - rect.left) / rect.width) * 100
    const yPercentMob = ((event.clientY - rect.top) / rect.height) * 100

    setMobileBtnPosition({ xPercentMob, yPercentMob })
    setInputs({ ...Inputs, MobilebtnX: xPercentMob, MobilebtnY: yPercentMob })
  }

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Widgets)) {
      history.push('/')
    }
    GetCategoryList()
    setIsAuth(true)
    setLoading(false)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AddBanner
    if (urlParams.id !== undefined) {
      document.title = Title.EditBanner
      GetBannerDetail()
    } else {
      setTimeout(() => {
        initDesktopImagePlugin()
        initMobileImagePlugin()
      }, 500)
    }
    GetPageList()
  }, [urlParams.id])

  const GetPageList = () => {
    HttpService.getApi(API.GetContentManagementList).then((response) => {
      setPages(response.data.result)
    })
  }
  const GetCategoryList = (selectedCategory = null) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      if (response.data.result) {
        // filter parent category
        const parentCategories = response.data.result[0].filter(
          (x) => x.parent_id === 1 && x.status
        )
        // setDiamondShapeCategories(response.data.result[0].filter(x => x.is_diamond_category === 1));
        // console.log(parentCategories)
        const categories = []

        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id && x.status
          )
          const subcategories = []

          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id && x.status
            )
            const subchildcategories = []

            filteredSubChildCategories.map((subchilditem) => {
              const filteredChildCategories = response.data.result[0].filter(
                (x) => x.parent_id === subchilditem.id && x.status
              )
              const childcategories = []

              filteredChildCategories.map((childitem) => {
                const filteredChildrenCategories = response.data.result[0].filter(
                  (x) => x.parent_id === childitem.id && x.status
                )
                const childrencategories = []
                filteredChildrenCategories.map((childrenitem) => {
                  let checked = false
                  if (
                    (urlParams.id !== undefined && Inputs.category_id === childrenitem.id) ||
                    selectedCategory === childrenitem.id
                  )
                    checked = true
                  childrencategories.push({
                    label: childrenitem.name,
                    value: childrenitem.id,
                    checked
                    // children: subcategories
                  })
                  return true
                })

                let checked = false
                if (
                  (urlParams.id !== undefined && Inputs.category_id === childitem.id) ||
                  selectedCategory === childitem.id
                )
                  checked = true
                childcategories.push({
                  label: childitem.name,
                  value: childitem.id,
                  checked,
                  children: childrencategories
                })
                return true
              })

              let checked = false
              if (
                (urlParams.id !== undefined && Inputs.category_id === subchilditem.id) ||
                selectedCategory === subchilditem.id
              )
                checked = true
              subchildcategories.push({
                label: subchilditem.name,
                value: subchilditem.id,
                checked,
                children: childcategories
              })
              return true
            })

            let checked = false
            if (
              (urlParams.id !== undefined && Inputs.category_id === subitem.id) ||
              selectedCategory === subitem.id
            )
              checked = true
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked,
              children: subchildcategories
            })
            return true
          })
          let checked = false
          if (
            (urlParams.id !== undefined && Inputs.category_id === item.id) ||
            selectedCategory === item.id
          )
            checked = true
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked
          })
          return true
        })
        setCategories(categories)
      }
    })
  }

  const updateCategoryDropdown = () => {
    Categories.map((item, index) => {
      if (item.value === Inputs.category_id) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      if (item.children) {
        item.children.map((subitem, subindex) => {
          if (subitem.value === Inputs.category_id) {
            Categories[index].children[subindex].checked = true
          } else {
            Categories[index].children[subindex].checked = false
          }
          if (subitem.children) {
            subitem.children.map((firstlevelsubitem, firstlevelsubindex) => {
              if (firstlevelsubitem.value === Inputs.category_id) {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = true
              } else {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = false
              }
              if (firstlevelsubitem.children) {
                firstlevelsubitem.children.map((secondlevelsubitem, secondlevelsubindex) => {
                  if (secondlevelsubitem.value === Inputs.category_id) {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = true
                  } else {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = false
                  }
                  return true
                })
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })
  }

  const onChangeCategory = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      setInputs({ ...Inputs, selectedCategoryId: selectedNodes[0].value })
      Inputs.selectedCategoryId = Inputs.category_id = selectedNodes[0].value
    } else {
      setInputs({ ...Inputs, selectedCategoryId: '' })
    }
    updateCategoryDropdown()
  }

  const GetBannerDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetBanner, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0][0]

        setInputs({ id: data.id, name: data.name, status: data.status })
        if (data.desktop_main_image !== '') {
          initDesktopImagePlugin(data.desktop_main_image)
        } else {
          initDesktopImagePlugin()
        }
        if (data.mobile_main_image !== '') {
          initMobileImagePlugin(data.mobile_main_image)
        } else {
          initMobileImagePlugin()
        }
        if (data !== null && data !== undefined) {
          const xPercentDesk = data.desk_btn_x_position
          const yPercentDesk = data.desk_btn_y_position
          const xPercentMob = data.mob_btn_x_position
          const yPercentMob = data.mob_btn_y_position
          setInputs({
            ...Inputs,
            btn_text: data.btn_text,
            name: data.name,
            status: data.status,
            prevMobImg: data.mobile_main_image,
            prevDeskImg: data.desktop_main_image,
            link_type: data.link_type,
            link: data.link_type === 'custom_link' ? data.link : 0,
            external_link: data.link_type === 'external_link' ? data.link : 0,
            page_id: data.page_id,
            selectedCategoryId: data.category_id,
            MobilebtnX: xPercentMob,
            MobilebtnY: yPercentMob,
            DesktopbtnX: xPercentDesk,
            DesktopbtnY: yPercentDesk,
            desk_btn_theme:
              data.desk_btn_theme !== null ? data.desk_btn_theme : Inputs.desk_btn_theme,
            mob_btn_theme: data.mob_btn_theme !== null ? data.mob_btn_theme : Inputs.mob_btn_theme
          })
          setDesktopBtnPosition({ xPercentDesk, yPercentDesk })
          setMobileBtnPosition({ xPercentMob, yPercentMob })
          GetCategoryList(data.category_id)
        }
      }
    })
  }
  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value
    if (field === 'status') Inputs[field] = e.target.checked
    else Inputs[field] = fieldval
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (DeskImg === 'invalid') {
      setDesktopImage(false)
    }
    console.log(validator.current)

    if (
      !validator.current.allValid() ||
      DeskImg === 'invalid' ||
      IsDesktopImage === false ||
      IsDesktopImageSize === true ||
      IsDesktopValidFile === false
    ) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const param = {
      _id: urlParams.id !== undefined && urlParams.id !== null ? urlParams.id : Inputs.id,
      _name: Inputs.name.trim(),
      _desktop_main_image: DeskImg,
      _mobile_main_image: MobileImg,
      _status: Inputs.status ? 1 : 0,
      _desk_btnX: Inputs.DesktopbtnX,
      _desk_btnY: Inputs.DesktopbtnY,
      _Mob_btnX: Inputs.MobilebtnX,
      _Mob_btnY: Inputs.MobilebtnY,
      _link:
        Inputs.link_type === 'custom_link'
          ? Inputs.link === 0
            ? ''
            : Inputs.link
          : Inputs.link_type === 'external_link'
            ? Inputs.external_link === 0
              ? ''
              : Inputs.external_link
            : Inputs.link,
      _link_type: Inputs.link_type,
      _category_id: Inputs.selectedCategoryId,
      _page_id: Inputs.page_id,
      _desk_btn_theme: Inputs.desk_btn_theme,
      _mob_btn_theme: Inputs.mob_btn_theme,
      _btn_text: Inputs.btn_text
    }
    setLoading(true)
    HttpService.postApi(API.SetBanner, param).then((response) => {
      if (response.data.message) {
        toast.warning(response.data.message)
        setLoading(false)
        initDesktopImagePlugin(DeskImg)
        initMobileImagePlugin(MobileImg)
        setForceUpdate(!isForceUpdate)
        return
      }
      validator.current.hideMessages()
      setForceUpdate(!isForceUpdate)
      if (response.data.result[0][0].result === 1) {
        setTimeout(() => {
          history.push('/widgets/banner')
          setLoading(false)
          if (urlParams.id === undefined) toast.success(Messages.RecordAdded)
          else toast.success(Messages.RecordUpdated)
        }, 8000)
      }
    })
  }
  const initMobileImagePlugin = (image1 = null) => {
    if (image1 !== '' && image1 !== null) {
      new FileUploadWithPreview('mobileimage', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image1]
      })
      setMobileImage(true)
    } else {
      new FileUploadWithPreview('mobileimage', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  const initDesktopImagePlugin = (image = null) => {
    if (image !== '' && image !== null) {
      new FileUploadWithPreview('desktopimage', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image]
      })
      setDesktopImage(true)
    } else {
      new FileUploadWithPreview('desktopimage', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  window.addEventListener('fileUploadWithPreview:imagesAdded', function (e) {
    if (e.detail.uploadId === 'desktopimage') {
      const imageType = e.detail.cachedFileArray[0].type

      const size = e.detail.cachedFileArray[0].size
      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setDeskImg(result)
          })
          setDesktopImage(true)
          setDesktopValidFile(true)
          setDesktopImageSize(false)
        } else {
          setDesktopImageSize(true)

          setDesktopImage(true)
          setDeskImg('')
        }
      } else {
        setDeskImg('')
        setDesktopImage(true)
        setDesktopValidFile(false)
        setDesktopImageSize(false)
      }
    } else if (e.detail.uploadId === 'mobileimage') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setMobileImg(result)
          })
          setMobileImage(true)
          setMobileValidFile(true)
          setMobileImageSize(false)
        } else {
          setMobileImageSize(true)
        }
      } else {
        setMobileImg('')
        setMobileImage(true)
        setMobileValidFile(false)
        setMobileImageSize(false)
      }
    }
  })
  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (e.detail.uploadId === 'desktopimage') {
      setDeskImg('')
      setDesktopValidFile(true)
      setDesktopImageSize(false)
      setDesktopImage(false)
    } else if (e.detail.uploadId === 'mobileimage') {
      setMobileImg('')
      setMobileValidFile(true)
      setMobileImageSize(false)
    }
  })

  const handleMenuInputChanges = (e) => {
    setInputs({ ...Inputs, link_type: e.target.value })
    if (e.target.value === 'category') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        link: Inputs.link === '' ? 0 : Inputs.link,
        selectedCategoryId: Inputs.selectedCategoryId === 0 ? '' : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
        link_type: e.target.value
      })
    } else if (e.target.value === 'page') {
      setInputs({
        ...Inputs,
        link: Inputs.link === '' ? 0 : Inputs.link,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
        page_id: Inputs.page_id === 0 ? '' : Inputs.page_id,
        link_type: e.target.value
      })
    } else if (e.target.value === 'custom_link') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        link: Inputs.link === 0 ? '' : Inputs.link,
        link_type: e.target.value,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link
      })
    } else if (e.target.value === 'blank') {
      setInputs({
        ...Inputs,
        page_id: 0,
        selectedCategoryId: 0,
        link: 0,
        link_type: e.target.value,
        external_link: 0
      })
    } else if (e.target.value === 'external_link') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === 0 ? '' : Inputs.external_link,
        link: Inputs.link === '' ? 0 : Inputs.link,
        link_type: e.target.value
      })
    }
    setForceUpdate(!isForceUpdate)
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditBanner : Title.AddBanner}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={handleInputChanges}
                        onKeyUp={handleInputChanges}
                        defaultValue={Inputs.name}
                        placeholder="Name"
                      />
                      {validator.current.message('Name', Inputs.name, 'required|max:255', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Button Text</label>
                      <input
                        type="text"
                        className="form-control"
                        name="btn_text"
                        onChange={handleInputChanges}
                        onKeyUp={handleInputChanges}
                        defaultValue={Inputs.btn_text}
                        placeholder="Button Text"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Link Type</label>
                      <select
                        className="form-control"
                        name="link_type"
                        onChange={handleMenuInputChanges}
                        value={Inputs.link_type}
                      >
                        <option value="">Select</option>
                        <option value="category">Category</option>
                        <option value="page">Page</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="external_link">External link</option>
                        <option value="blank">Blank</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'category' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Category</label>
                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          placeholder="Choose"
                          multi={false}
                          data={Categories}
                          onChange={onChangeCategory}
                          mode="radioSelect"
                          className="bootstrap-demo w-100"
                        />
                      )}
                      <input
                        type="hidden"
                        className="form-control"
                        name="category"
                        onBlur={() => validator.current.showMessageFor('category')}
                        value={Inputs.selectedCategoryId}
                      />{' '}
                      {validator.current.message(
                        'Category',
                        Inputs.selectedCategoryId,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'page' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Page</label>
                      <select
                        className="form-control"
                        name="page_id"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('page')}
                        value={Inputs.page_id}
                      >
                        <option
                          key={''}
                          value={''}
                        >
                          select
                        </option>
                        {Pages.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {validator.current.message('Page', Inputs.page_id, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'custom_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>Custom Link</label>{' '}
                      <input
                        type="text"
                        className="form-control"
                        name="link"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('link')}
                        value={Inputs.link}
                        placeholder="Custom Link"
                      />
                      <label
                        style={{ color: '#505050' }}
                        className="note mt-1"
                      >
                        {' '}
                        {'(Do not include "https://www.example.com/" in link.)'}
                      </label>
                      {validator.current.message('Custom Link', Inputs.link, 'required|noDomain', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'external_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>External Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="external_link"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('external_link')}
                        value={Inputs.external_link}
                        placeholder="External Link"
                      />
                      {validator.current.message(
                        'External Link',
                        Inputs.external_link,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={
                      Inputs.link_type === 'blank' || Inputs.link_type === ''
                        ? {}
                        : { display: 'none' }
                    }
                  >
                    <div className="form-group"></div>
                  </div>
                </div>

                <div className="row widget-banner-row">
                  <div className="col-md-6 col-lg-6">
                    <h5>
                      <b>Desktop Banners</b>
                    </h5>
                    <div className="mt-3 mb-4">
                      <div
                        className="custom-file-container"
                        data-upload-id="desktopimage"
                      >
                        <label>Desktop Banner</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed. Size should be 1920x820 pixels.)'}
                        </label>
                      </div>
                      <div
                        style={!IsDesktopValidFile ? {} : { display: 'none' }}
                        className="error pt-2 mt-0 pl-3 pb-3"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsDesktopImageSize ? {} : { display: 'none' }}
                        className="error pt-0 mt-0 pl-3 pb-2"
                      >
                        Maximum file size should be 2MB.
                      </div>
                      <div
                        style={IsDesktopImage ? { display: 'none' } : {}}
                        className="error pt-2 mt-0 pl-3 pb-3"
                      >
                        Desktop Image is required.
                      </div>
                    </div>
                    <div>
                      <div className="mb-3">
                        <h6 className="mt-2">Desktop Button Theme</h6>
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="desk_btn_theme"
                            onChange={handleInputChanges}
                            value={Inputs.desk_btn_theme}
                          >
                            <option value={'black'}>Black</option>
                            <option value={'white'}>White</option>
                            <option value={'theme_color'}>Theme color</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <h6 className="mt-2">Desktop Button Position</h6>
                        <div
                          className="mt-1"
                          style={{ position: 'relative', display: 'inline-block' }}
                        >
                          <img
                            src={
                              DeskImg !== '' && DeskImg !== 'invalid'
                                ? DeskImg
                                : Common.setImage('assets/images/icon/place_holder_1.jpg')
                            }
                            alt="Responsive Click"
                            ref={DesktopImageRef}
                            onClick={handleDesktopImageClick}
                            style={{
                              width: '100%',
                              height: 'auto',
                              cursor: 'crosshair'
                            }}
                          />
                          {DesktopBtnPosition && (
                            <button
                              className="btn bg-transparent p-0"
                              style={{
                                position: 'absolute',
                                fontSize: '18px',
                                top: `${DesktopBtnPosition.yPercentDesk}%`,
                                left: `${DesktopBtnPosition.xPercentDesk}%`,
                                transform: 'translate(-50%, -50%)',
                                zIndex: 10
                              }}
                              onClick={(e) => e.preventDefault()}
                            >
                              📍
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <h5>
                      <b>Mobile Banners</b>
                    </h5>
                    <div className="mt-3 mb-4">
                      <div
                        className="custom-file-container mb-3"
                        data-upload-id="mobileimage"
                      >
                        <label>Mobile Banner</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed. Size should be 767x375 pixels.)'}
                        </label>
                      </div>
                      <div style={IsMobileImage ? { display: 'none' } : { display: 'block' }}>
                        <small className="error">Image is required.</small>
                      </div>
                      <div
                        style={!IsMobileValidFile ? {} : { display: 'none' }}
                        className="error pt-2 pb-3 mt-0 pl-3"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsMobileImageSize ? {} : { display: 'none' }}
                        className="error pt-0 pb-2 mt-0 pl-3"
                      >
                        Maximum file size should be 2MB.
                      </div>
                    </div>
                    <div>
                      <div className="mb-3">
                        <h6 className="mt-2">Mobile Button Theme</h6>
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="mob_btn_theme"
                            onChange={handleInputChanges}
                            value={Inputs.mob_btn_theme}
                          >
                            <option value={'black'}>Black</option>
                            <option value={'white'}>White</option>
                            <option value={'theme_color'}>Theme color</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <h6>Set Mobile Button Position</h6>
                        <div
                          className="mt-1"
                          style={{ position: 'relative', display: 'inline-block' }}
                        >
                          <img
                            src={
                              MobileImg !== ''
                                ? MobileImg
                                : Common.setImage('assets/images/icon/place_holder_1.jpg')
                            }
                            alt="Responsive Click"
                            ref={MobileImageRef}
                            onClick={handleMobileImageClick}
                            style={{
                              width: '100%',
                              height: 'auto',
                              cursor: 'crosshair'
                            }}
                          />
                          {MobileBtnPosition && (
                            <button
                              className="btn bg-transparent p-0"
                              style={{
                                position: 'absolute',
                                fontSize: '18px',
                                top: `${MobileBtnPosition.yPercentMob}%`,
                                left: `${MobileBtnPosition.xPercentMob}%`,
                                transform: 'translate(-50%, -50%)',
                                zIndex: 10
                              }}
                              onClick={(e) => e.preventDefault()}
                            >
                              📍
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/widgets/banner"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddBanner
